module.exports = {};



// WEBPACK FOOTER //
// ./~/core-js/library/modules/_iterators.js